import Model from "src/models/base/model.js";

class QuotationCte extends Model{
  resourceName() {
    return "quotation_invoices";
  }

  fields() {
    return {
      key: "",
      number: "",
      name: "",
      path: "",
      receive_value: "",
    }
  }
}

export default new QuotationCte();
